// Custom Tabs Component
class CustomTabsComponent extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.imageWrappers = [];
    this.sectionElement = null;
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.custom-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.custom-tabs__panel'));
    this.imageWrappers = Array.from(this.querySelectorAll('.custom-tabs__image-wrapper'));
    
    // Find the section element for background color changes
    this.sectionElement = this.closest('.custom-tabs-section');

    if (this.tabs.length === 0 || this.panels.length === 0) {
      return;
    }

    // Set initial active tab
    this.setActiveTab(0);

    // Add event listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.handleTabClick(index));
      tab.addEventListener('keydown', (e) => this.handleKeyDown(e, index));
    });
  }

  handleTabClick(index) {
    if (index === this.activeIndex) {
      return;
    }

    this.setActiveTab(index);
  }

  handleKeyDown(event, index) {
    let newIndex = index;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = index > 0 ? index - 1 : this.tabs.length - 1;
        this.setActiveTab(newIndex);
        this.tabs[newIndex].focus();
        break;
      case 'ArrowRight':
        event.preventDefault();
        newIndex = index < this.tabs.length - 1 ? index + 1 : 0;
        this.setActiveTab(newIndex);
        this.tabs[newIndex].focus();
        break;
      case 'Home':
        event.preventDefault();
        this.setActiveTab(0);
        this.tabs[0].focus();
        break;
      case 'End':
        event.preventDefault();
        this.setActiveTab(this.tabs.length - 1);
        this.tabs[this.tabs.length - 1].focus();
        break;
    }
  }

  setActiveTab(index) {
    if (index < 0 || index >= this.tabs.length) {
      return;
    }

    const activeTab = this.tabs[index];
    const bgColor = activeTab.getAttribute('data-bg-color') || '#ffffff';
    const textColor = activeTab.getAttribute('data-text-color') || '#000000';

    // Update tabs
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update panels with crossfade
    this.panels.forEach((panel, i) => {
      if (i === index) {
        // Remove hidden attribute first
        panel.removeAttribute('hidden');
        
        // Trigger typewriter effect by removing and re-adding class
        const contentText = panel.querySelector('.custom-tabs__content-text');
        if (contentText instanceof HTMLElement) {
          // Force reflow to restart animations
          void contentText.offsetHeight;
        }
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Update images with crossfade animation
    this.imageWrappers.forEach((wrapper) => {
      const wrapperIndex = parseInt(wrapper.getAttribute('data-image-index'), 10);
      const isActive = wrapperIndex === index;
      if (isActive) {
        wrapper.classList.add('active');
      } else {
        wrapper.classList.remove('active');
      }
    });

    // Update section background color and text color with crossfade
    if (this.sectionElement && this.sectionElement instanceof HTMLElement) {
      // Update the section element text color
      this.sectionElement.style.color = textColor;
      
      // Update the section-background element (sibling of section element)
      const sectionBackground = this.sectionElement.previousElementSibling;
      if (sectionBackground && sectionBackground.classList.contains('section-background')) {
        sectionBackground.style.backgroundColor = bgColor;
      }
      
      // Also update the section itself as fallback
      this.sectionElement.style.backgroundColor = bgColor;
    }

    this.activeIndex = index;
  }
}

if (!customElements.get('custom-tabs-component')) {
  customElements.define('custom-tabs-component', CustomTabsComponent);
}



